import { useEffect, useState } from "react";
import CloseRounded from "../assets/icons/close-rounded";
import Search from "../assets/icons/search";
import "../assets/styles/views/faq.scss";
import Download from "../assets/icons/download";
import { useOutletContext } from "react-router-dom";
import BackArrowButton from "../components/BackArrowButton";

export default function Faq() {
  const [context, setContext] = useOutletContext();

  const faq_data = [
    {
      category_name: "App-registrazione download",
      arguments_list: [
        {
          question:
            "Per quali piattaforme/sistemi operativi è disponibile questa applicazione?",
          answer:
            'La "Progressive Web App" Q8 F&A è disponibile per tutte le piattaforme, sia desktop che mobile. Per la connessione è sufficiente un qualsiasi browser web e una connessione a Internet.',
        },
        {
          question: "Quale è la procedura per iniziare a utilizzare l’app?",
          answer:
            "Accedi alla nuova web app copiando e incollando sul tuo browser il link che trovi nel sul Portale Gestori.<br/>Nella pagina del Portale Gestori potrai trovare anche il QR code da inquadrare per accedere direttamente alla web app da smart phone.",
        },
        {
          question: "Quando devo inserire il codice cliente?",
          answer:
            "Il codice cliente va inserito solo durante la prima registrazione, riservata al gestore/appaltatore responsabile del punto vendita",
        },
        {
          question: "Quali dati devono essere inseriti al login nell’app?",
          answer:
            "Per eseguire il login è necessario inserire lo username e la password di accesso. Per l’utente principale del punto vendita lo username corrisponde all’indirizzo mail con cui si è fatta la registrazione. Per gli utenti secondari (2 per ogni gestore) lo username è composto nel seguente modo:<br>CODICEGESTORE_1 oppure CODICEGESTORE_2<br>La password degli utenti secondari viene inviata all’indirizzo e-mail dell’utente principale al momento dell’attivazione.<br>La password va cambiata al primo accesso dell’utente all’app, e ha durata di 3 mesi dopodiché deve essere nuovamente cambiata.",
        },
        {
          question:
            "Ho inserito i dati per l’accesso come da vostre indicazioni ma non riesco ad entrare, mi compare un messaggio di errore che mi dice che l’utente non esiste/è già stato attribuito/credenziali non valide?",
          answer:
            'Probabilmente hai inserito dei dati di login (email/password) errati. Per ricevere una nuova password clicca su “Hai dimenticato la password” e segui le istruzioni. Se continui ad avere problemi di accesso invia un messaggio e-mail all’indirizzo <a href="mailto:formazionerete@q8.it" target="_blank">formazionerete@q8.it</a>, descrivendo il problema riscontrato',
        },
        {
          question:
            "Non accedo all'applicazione da diverso tempo, ho provato a rientrare ma mi dice che le credenziali non sono valide, cosa devo fare?",
          answer:
            'In ottemperanza alla normativa sulla tutela e la protezione dei dati gli utenti vengono disattivati dopo 6 mesi di inattività (cioè, se l’utente per 6 mesi non accede all’app). L’utenza può essere riattivata inviando una richiesta via e-mail all’indirizzo <a href="mailto:formazionerete@q8.it" target="_blank">formazionerete@q8.it</a>',
        },
      ],
    },
    {
      category_name: "Utenti associati",
      arguments_list: [
        {
          question: "Come posso attivare altre utenze oltre la mia?",
          answer:
            "Con il comando <b>menu > configurazioni > gestione account associati</b> si accede alla lista di tutti i PV associati al codice cliente inserito. Basta cliccare sull’oggetto per attivare il relativo PV. Le credenziali degli utenti secondari verranno inviate via e-mail all’indirizzo dell’utente principale. Le credenziali appena ricevute dovranno essere cambiate appena dopo il primo accesso",
        },
        {
          question: "Come disattivare le utenze aggiuntive create?",
          answer:
            "Dall'icona menu posizionata in alto a destra scegliere la voce <b>Account</b>. Viene visualizzata lista delle utenze secondarie associate al gestore. Per ciascun utente secondario è indicato l’attuale stato di attivazione (ATTIVO/NON ATTIVO). Per disattivare un utente è sufficiente cliccare sul tasto/switch di attivazione, il sistema chiederà un’ulteriore conferma.",
        },
        {
          question:
            "Come effettuare il primo accesso per gli utenti associati creati",
          answer:
            "L’utenza gestore deve inoltrare ai suoi collaboratori le credenziali temporanee che ha ricevuto per email dal sistema al momento dell’attivazione",
        },
        {
          question:
            "Se un collaboratore termina la sua attività cosa fare con l’utenza che avevo creato per lui?",
          answer:
            "E' opportuno disabilitare le utenze assegnate ad operatori che hanno terminato la loro collaborazione",
        },
      ],
    },
    {
      category_name: "Area formazione",
      arguments_list: [
        {
          question: "Come si accede all’area formazione?",
          answer:
            "L’area Formazione è la pagina principale dell’app, cui si accede non appena completata la procedura di registrazione o di login. Nella pagina vengono visualizzati tutti i “percorsi” (intesi come moduli formativi ciascuno contenente più pillole formative). Cliccando in corrispondenza di un percorso si accede all’elenco delle pillole",
        },
        {
          question: "Come visualizzo una pillola? ",
          answer:
            "Ogni percorso contiene un elenco di pillole, per ciascuna è visualizzato il titolo, la durata, lo stato attuale di completamento da parte dell’utente. Cliccando in corrispondenza di una pillola viene visualizzato il contenuto corrispondente, sia esso video, documento o altra tipologia; è necessario essere connessi tramite WiFi o tramite connessione dati.",
        },
        {
          question: "Perché non riesco a visualizzare una pillola?",
          answer:
            "Per la visualizzazione è necessario essere connessi tramite WiFi o tramite connessione dati. L'applicazione mostra un messaggio quando si è disconessi dalla rete. Verifica la tua connessione",
        },
      ],
    },
    {
      category_name: "Checklist",
      arguments_list: [
        {
          question:
            "Come si consultano le checklist (per gli utenti con profilo RCR)?",
          answer:
            "Con il comando <strong>menu > checklist</strong> si accede alle checklist in stato “completato”, in ordine cronologico dalla più recente alla più vecchia, cliccandoci sopra sarà possibile consultare il dettaglio",
        },
        {
          question: "Come si stampano le checklist?",
          answer:
            "Con il tasto “Condividi” si invia una versione stampabile della checklist selezionata. Sarà sufficiente inserire gli indirizzi e-mail separati dalla virgola",
        },
      ],
    },
    {
      category_name: "Documenti",
      arguments_list: [
        {
          question: "Come si consultano i documenti?",
          answer:
            "Con il comando <strong>menu > Documenti</strong>, vengono visualizzati tutti i documenti che l'RCR di competenza ha condiviso con i suoi PV. Per consultare è necessario cliccare sul documento. In questo modo l’app avvia il download del file corrispondente.",
        },
      ],
    },
  ];

  const [current_search, setCurrentSearch] = useState("");
  const [faq_list, setFaqList] = useState(faq_data);

  useEffect(() => {
    if (!!current_search) {
      let list = [];
      faq_list.map((item, index) => {
        let finded = item.arguments_list.filter(
          (x) =>
            x.question
              .toUpperCase()
              .includes(current_search.toLocaleUpperCase()) ||
            x.answer.toUpperCase().includes(current_search.toLocaleUpperCase())
        );
        if (finded.length > 0) {
          let category = { ...item };
          category.arguments_list = finded;
          list.push(category);
        }
      });
      setFaqList(list);
    } else setFaqList(faq_data);
  }, [current_search]);

  return (
    <>
      <BackArrowButton path={context.session ? "/" : -1} />
      <section className="faq main-panel w-100">
        <div className="mx-auto p-3">
          <div className="d-md-flex align-items-center">
            <a
              style={{ width: "fit-content" }}
              href="/manuale.pdf"
              download
              className="download-manual q8-blue-button text-white d-flex align-items-center mb-3 p-2 ms-auto me-md-3 d-block"
            >
              <Download size={15} color="#ffffff" className="me-2" />
              Scarica il manuale
            </a>
            <div className="search mb-4 mb-md-3 position-relative">
              <input
                type="text"
                placeholder="Cerca"
                value={current_search}
                className="w-100 shadows mt-0 px-3 py-2"
                onChange={(e) => setCurrentSearch(e.target.value)}
              />
              {!!current_search ? (
                <CloseRounded
                  color="#2d2d2d"
                  size={20}
                  className="position-absolute"
                  onClick={() => setCurrentSearch("")}
                />
              ) : (
                <Search
                  color="#cccccc"
                  size={22}
                  className="position-absolute"
                />
              )}
            </div>
          </div>

          {faq_list.length > 0 ? (
            faq_list.map((item, index) => {
              return (
                <div className="mb-5" key={index}>
                  <h2 className="mt-0 mb-3">{item.category_name}</h2>
                  {item.arguments_list.map((sub_item, sub_index) => {
                    return (
                      <details className="mb-3 border" key={sub_index}>
                        <summary
                          dangerouslySetInnerHTML={{
                            __html: sub_item.question,
                          }}
                        ></summary>
                        <p
                          className="mb-4 mt-3 d-block"
                          dangerouslySetInnerHTML={{ __html: sub_item.answer }}
                        ></p>
                      </details>
                    );
                  })}
                </div>
              );
            })
          ) : (
            <span className="nothing-found-message d-block w-100 text-center mt-5 mb-5">
              Nessun risultato da mostrare
            </span>
          )}

          <strong className="mb-5 text-center d-block mail-to-info">
            Per altri quesiti contattare{" "}
            <a href="mailto:formazionerete@q8.it">formazionerete@q8.it</a>{" "}
            indicando il codice PV
          </strong>
        </div>
      </section>
    </>
  );
}
